import * as React from "react";
import CurrencyFormat from "react-currency-format";
var onValueChange = function (values, callback) {
    var value = values.value === "-" ? undefined : values.value;
    return !!callback ? callback(value) : undefined;
};
/**
 *
 * @param props
 */
export var CurrencyInput = function (props) {
    var onChangeValue = function (values) {
        onValueChange(values, props.onChange);
    };
    var handleBlur = function (e) {
        if (props.onBlur) {
            // If `onBlur` is triggered, pass the raw numeric value or formatted string
            var numericValue = e.target.value;
            props.onBlur(numericValue);
        }
    };
    return (props.withPrefix ? (React.createElement(CurrencyFormat, { value: props.amount, thousandSeparator: ".", decimalSeparator: ",", displayType: !!props.isInput ? "input" : "text", className: props.className, decimalScale: props.withoutDecimal ? 0 : 2, prefix: "€", fixedDecimalScale: true, allowNegative: false, min: props.min, max: props.max, onValueChange: onChangeValue, placeholder: props.placeholder, disabled: props.disabled, onBlur: function (e) { return handleBlur(e); } })) : (React.createElement(CurrencyFormat, { value: props.amount, thousandSeparator: ".", decimalSeparator: ",", displayType: !!props.isInput ? "input" : "text", className: props.className, decimalScale: props.withoutDecimal ? 0 : 2, fixedDecimalScale: true, allowNegative: true, min: props.min, max: props.max, onValueChange: onChangeValue, placeholder: props.placeholder, disabled: props.disabled, onBlur: function (e) { return handleBlur(e); } })));
};
export var testUtil = {
    onValueChange: onValueChange,
};
